import { ElementsSDK } from '@yiluhub/ui-sdk-react';

export type countryISO3166Map = {
  alpha3: string;
  alpha2: string;
  country: { en: string; de: string };
};

// ISO 3166 international standard
export const countryCodeMap: countryISO3166Map[] = [
  { alpha3: 'AFG', alpha2: 'AF', country: { en: 'Afghanistan', de: 'Afghanistan' } },
  { alpha3: 'ALA', alpha2: 'AX', country: { en: 'Åland Islands', de: 'Ålandinseln' } },
  { alpha3: 'ALB', alpha2: 'AL', country: { en: 'Albania', de: 'Albanien' } },
  { alpha3: 'DZA', alpha2: 'DZ', country: { en: 'Algeria', de: 'Algerien' } },
  {
    alpha3: 'ASM',
    alpha2: 'AS',
    country: { en: 'American Samoa', de: 'Amerikanischen Samoa-Inseln' },
  },
  { alpha3: 'AND', alpha2: 'AD', country: { en: 'Andorra', de: 'Andorra' } },
  { alpha3: 'AGO', alpha2: 'AO', country: { en: 'Angola', de: 'Angola' } },
  { alpha3: 'AIA', alpha2: 'AI', country: { en: 'Anguilla', de: 'Anguilla' } },
  { alpha3: 'ATA', alpha2: 'AQ', country: { en: 'Antarctica', de: 'Antarktis' } },
  {
    alpha3: 'ATG',
    alpha2: 'AG',
    country: { en: 'Antigua and Barbuda', de: 'Antigua und Barbuda' },
  },
  { alpha3: 'ARG', alpha2: 'AR', country: { en: 'Argentina', de: 'Argentinien' } },
  { alpha3: 'ARM', alpha2: 'AM', country: { en: 'Armenia', de: 'Armenien' } },
  { alpha3: 'ABW', alpha2: 'AW', country: { en: 'Aruba', de: 'Aruba' } },
  { alpha3: 'AUS', alpha2: 'AU', country: { en: 'Australia', de: 'Australien' } },
  { alpha3: 'AUT', alpha2: 'AT', country: { en: 'Austria', de: 'Österreich' } },
  { alpha3: 'AZE', alpha2: 'AZ', country: { en: 'Azerbaijan', de: 'Aserbaidschan' } },
  { alpha3: 'BHS', alpha2: 'BS', country: { en: 'Bahamas', de: 'Bahamas' } },
  { alpha3: 'BHR', alpha2: 'BH', country: { en: 'Bahrain', de: 'Bahrain' } },
  { alpha3: 'BGD', alpha2: 'BD', country: { en: 'Bangladesh', de: 'Bangladesch' } },
  { alpha3: 'BRB', alpha2: 'BB', country: { en: 'Barbados', de: 'Barbados' } },
  { alpha3: 'BLR', alpha2: 'BY', country: { en: 'Belarus', de: 'Belarus' } },
  { alpha3: 'BEL', alpha2: 'BE', country: { en: 'Belgium', de: 'Belgien' } },
  { alpha3: 'BLZ', alpha2: 'BZ', country: { en: 'Belize', de: 'Belize' } },
  { alpha3: 'BEN', alpha2: 'BJ', country: { en: 'Benin', de: 'Benin' } },
  { alpha3: 'BMU', alpha2: 'BM', country: { en: 'Bermuda', de: 'Bermuda' } },
  { alpha3: 'BTN', alpha2: 'BT', country: { en: 'Bhutan', de: 'Bhutan' } },
  {
    alpha3: 'BOL',
    alpha2: 'BO',
    country: { en: 'Bolivia (Plurinational State of)', de: 'Bolivien' },
  },
  {
    alpha3: 'BES',
    alpha2: 'BQ',
    country: { en: 'Bonaire, Sint Eustatius and Saba', de: 'Bonaire, Sint Eustatius und Saba' },
  },
  {
    alpha3: 'BIH',
    alpha2: 'BA',
    country: { en: 'Bosnia and Herzegovina', de: 'Bosnien und Herzegowina' },
  },
  { alpha3: 'BWA', alpha2: 'BW', country: { en: 'Botswana', de: 'Botswana' } },
  { alpha3: 'BVT', alpha2: 'BV', country: { en: 'Bouvet Island', de: 'Bouvet Island' } },
  { alpha3: 'BRA', alpha2: 'BR', country: { en: 'Brazil', de: 'Brasilien' } },
  {
    alpha3: 'IOT',
    alpha2: 'IO',
    country: {
      en: 'British Indian Ocean Territory',
      de: 'Britisches Territorium des Indischen Ozeans',
    },
  },
  { alpha3: 'BRN', alpha2: 'BN', country: { en: 'Brunei Darussalam', de: 'Brunei' } },
  { alpha3: 'BGR', alpha2: 'BG', country: { en: 'Bulgaria', de: 'Bulgarien' } },
  { alpha3: 'BFA', alpha2: 'BF', country: { en: 'Burkina Faso', de: 'Burkina Faso' } },
  { alpha3: 'BDI', alpha2: 'BI', country: { en: 'Burundi', de: 'Burundi' } },
  { alpha3: 'CPV', alpha2: 'CV', country: { en: 'Cabo Verde', de: 'Kap Verde' } },
  { alpha3: 'KHM', alpha2: 'KH', country: { en: 'Cambodia', de: 'Kambodscha' } },
  { alpha3: 'CMR', alpha2: 'CM', country: { en: 'Cameroon', de: 'Kamerun' } },
  { alpha3: 'CAN', alpha2: 'CA', country: { en: 'Canada', de: 'Kanada' } },
  { alpha3: 'CYM', alpha2: 'KY', country: { en: 'Cayman Islands', de: 'Cayman Inseln' } },
  {
    alpha3: 'CAF',
    alpha2: 'CF',
    country: { en: 'Central African Republic', de: 'Zentral­afrikanische Republik' },
  },
  { alpha3: 'TCD', alpha2: 'TD', country: { en: 'Chad', de: 'Tschad' } },
  { alpha3: 'CHL', alpha2: 'CL', country: { en: 'Chile', de: 'Chile' } },
  { alpha3: 'CHN', alpha2: 'CN', country: { en: 'China', de: 'Volksrepublik China' } },
  { alpha3: 'CXR', alpha2: 'CX', country: { en: 'Christmas Island', de: 'Weihnachtsinsel' } },
  {
    alpha3: 'CCK',
    alpha2: 'CC',
    country: { en: 'Cocos (Keeling) Islands', de: 'Kokosinseln (Keelinginseln)' },
  },
  { alpha3: 'COL', alpha2: 'CO', country: { en: 'Colombia', de: 'Kolumbien' } },
  { alpha3: 'COM', alpha2: 'KM', country: { en: 'Comoros', de: 'Komoren' } },
  { alpha3: 'COG', alpha2: 'CG', country: { en: 'Congo', de: 'Kongo, Republik' } },
  {
    alpha3: 'COD',
    alpha2: 'CD',
    country: { en: 'Congo, Democratic Republic of the', de: 'Kongo, Demokratische Republik' },
  },
  { alpha3: 'COK', alpha2: 'CK', country: { en: 'Cook Islands', de: 'Cookinseln' } },
  { alpha3: 'CRI', alpha2: 'CR', country: { en: 'Costa Rica', de: 'Costa Rica' } },
  { alpha3: 'CIV', alpha2: 'CI', country: { en: "Côte d'Ivoire", de: 'Elfenbeinküste' } },
  { alpha3: 'HRV', alpha2: 'HR', country: { en: 'Croatia', de: 'Kroatien' } },
  { alpha3: 'CUB', alpha2: 'CU', country: { en: 'Cuba', de: 'Kuba' } },
  { alpha3: 'CUW', alpha2: 'CW', country: { en: 'Curaçao', de: 'Curaçao' } },
  { alpha3: 'CYP', alpha2: 'CY', country: { en: 'Cyprus', de: 'Zypern' } },
  { alpha3: 'CZE', alpha2: 'CZ', country: { en: 'Czechia', de: 'Tschechien' } },
  { alpha3: 'DNK', alpha2: 'DK', country: { en: 'Denmark', de: 'Dänemark' } },
  { alpha3: 'DJI', alpha2: 'DJ', country: { en: 'Djibouti', de: 'Dschibuti' } },
  { alpha3: 'DMA', alpha2: 'DM', country: { en: 'Dominica', de: 'Dominica' } },
  {
    alpha3: 'DOM',
    alpha2: 'DO',
    country: { en: 'Dominican Republic', de: 'Dominikanische Republik' },
  },
  { alpha3: 'ECU', alpha2: 'EC', country: { en: 'Ecuador', de: 'Ecuador' } },
  { alpha3: 'EGY', alpha2: 'EG', country: { en: 'Egypt', de: 'Ägypten' } },
  { alpha3: 'SLV', alpha2: 'SV', country: { en: 'El Salvador', de: 'El Salvador' } },
  { alpha3: 'GNQ', alpha2: 'GQ', country: { en: 'Equatorial Guinea', de: 'Äquatorialguinea' } },
  { alpha3: 'ERI', alpha2: 'ER', country: { en: 'Eritrea', de: 'Eritrea' } },
  { alpha3: 'EST', alpha2: 'EE', country: { en: 'Estonia', de: 'Estland' } },
  { alpha3: 'SWZ', alpha2: 'SZ', country: { en: 'Eswatini', de: 'Eswatini' } },
  { alpha3: 'ETH', alpha2: 'ET', country: { en: 'Ethiopia', de: 'Äthiopien' } },
  {
    alpha3: 'FLK',
    alpha2: 'FK',
    country: { en: 'Falkland Islands (Malvinas)', de: 'Falklandinseln (Malvinas)' },
  },
  { alpha3: 'FRO', alpha2: 'FO', country: { en: 'Faroe Islands', de: 'Färöer Inseln' } },
  { alpha3: 'FJI', alpha2: 'FJ', country: { en: 'Fiji', de: 'Fidschi' } },
  { alpha3: 'FIN', alpha2: 'FI', country: { en: 'Finland', de: 'Finnland' } },
  { alpha3: 'FRA', alpha2: 'FR', country: { en: 'France', de: 'Frankreich' } },
  { alpha3: 'GUF', alpha2: 'GF', country: { en: 'French Guiana', de: 'Französisch-Guayana' } },
  {
    alpha3: 'PYF',
    alpha2: 'PF',
    country: { en: 'French Polynesia', de: 'Französisch Polynesien' },
  },
  {
    alpha3: 'ATF',
    alpha2: 'TF',
    country: { en: 'French Southern Territories', de: 'Südfranzösische Territorien' },
  },
  { alpha3: 'GAB', alpha2: 'GA', country: { en: 'Gabon', de: 'Gabun' } },
  { alpha3: 'GMB', alpha2: 'GM', country: { en: 'Gambia', de: 'Gambia' } },
  { alpha3: 'GEO', alpha2: 'GE', country: { en: 'Georgia', de: 'Georgien' } },
  { alpha3: 'DEU', alpha2: 'DE', country: { en: 'Germany', de: 'Deutschland' } },
  { alpha3: 'GHA', alpha2: 'GH', country: { en: 'Ghana', de: 'Ghana' } },
  { alpha3: 'GIB', alpha2: 'GI', country: { en: 'Gibraltar', de: 'Gibraltar' } },
  { alpha3: 'GRC', alpha2: 'GR', country: { en: 'Greece', de: 'Griechenland' } },
  { alpha3: 'GRL', alpha2: 'GL', country: { en: 'Greenland', de: 'Grönland' } },
  { alpha3: 'GRD', alpha2: 'GD', country: { en: 'Grenada', de: 'Grenada' } },
  { alpha3: 'GLP', alpha2: 'GP', country: { en: 'Guadeloupe', de: 'Guadeloupe' } },
  { alpha3: 'GUM', alpha2: 'GU', country: { en: 'Guam', de: 'Guam' } },
  { alpha3: 'GTM', alpha2: 'GT', country: { en: 'Guatemala', de: 'Guatemala' } },
  { alpha3: 'GGY', alpha2: 'GG', country: { en: 'Guernsey', de: 'Guernsey' } },
  { alpha3: 'GIN', alpha2: 'GN', country: { en: 'Guinea', de: 'Guinea' } },
  { alpha3: 'GNB', alpha2: 'GW', country: { en: 'Guinea-Bissau', de: 'Guinea-Bissau' } },
  { alpha3: 'GUY', alpha2: 'GY', country: { en: 'Guyana', de: 'Guyana' } },
  { alpha3: 'HTI', alpha2: 'HT', country: { en: 'Haiti', de: 'Haiti' } },
  {
    alpha3: 'HMD',
    alpha2: 'HM',
    country: { en: 'Heard Island and McDonald Islands', de: 'Heard Island und McDonald Islands' },
  },
  { alpha3: 'VAT', alpha2: 'VA', country: { en: 'Holy See', de: 'Heiliger Stuhl' } },
  { alpha3: 'HND', alpha2: 'HN', country: { en: 'Honduras', de: 'Honduras' } },
  { alpha3: 'HKG', alpha2: 'HK', country: { en: 'Hong Kong', de: 'Hongkong' } },
  { alpha3: 'HUN', alpha2: 'HU', country: { en: 'Hungary', de: 'Ungarn' } },
  { alpha3: 'ISL', alpha2: 'IS', country: { en: 'Iceland', de: 'Island' } },
  { alpha3: 'IND', alpha2: 'IN', country: { en: 'India', de: 'Indien' } },
  { alpha3: 'IDN', alpha2: 'ID', country: { en: 'Indonesia', de: 'Indonesien' } },
  { alpha3: 'IRN', alpha2: 'IR', country: { en: 'Iran (Islamic Republic of)', de: 'Iran' } },
  { alpha3: 'IRQ', alpha2: 'IQ', country: { en: 'Iraq', de: 'Irak' } },
  { alpha3: 'IRL', alpha2: 'IE', country: { en: 'Ireland', de: 'Irland' } },
  { alpha3: 'IMN', alpha2: 'IM', country: { en: 'Isle of Man', de: 'Isle of Man' } },
  { alpha3: 'ISR', alpha2: 'IL', country: { en: 'Israel', de: 'Israel' } },
  { alpha3: 'ITA', alpha2: 'IT', country: { en: 'Italy', de: 'Italien' } },
  { alpha3: 'JAM', alpha2: 'JM', country: { en: 'Jamaica', de: 'Jamaika' } },
  { alpha3: 'JPN', alpha2: 'JP', country: { en: 'Japan', de: 'Japan' } },
  { alpha3: 'JEY', alpha2: 'JE', country: { en: 'Jersey', de: 'Jersey' } },
  { alpha3: 'JOR', alpha2: 'JO', country: { en: 'Jordan', de: 'Jordanien' } },
  { alpha3: 'KAZ', alpha2: 'KZ', country: { en: 'Kazakhstan', de: 'Kasachstan' } },
  { alpha3: 'KEN', alpha2: 'KE', country: { en: 'Kenya', de: 'Kenia' } },
  { alpha3: 'KIR', alpha2: 'KI', country: { en: 'Kiribati', de: 'Kiribati' } },
  {
    alpha3: 'PRK',
    alpha2: 'KP',
    country: { en: "Korea (Democratic People's Republic of)", de: 'Korea, Nord' },
  },
  { alpha3: 'KOR', alpha2: 'KR', country: { en: 'Korea, Republic of', de: 'Korea, Süd' } },
  { alpha3: 'KWT', alpha2: 'KW', country: { en: 'Kuwait', de: 'Kuwait' } },
  { alpha3: 'KGZ', alpha2: 'KG', country: { en: 'Kyrgyzstan', de: 'Kirgisistan' } },
  { alpha3: 'LAO', alpha2: 'LA', country: { en: "Lao People's Democratic Republic", de: 'Laos' } },
  { alpha3: 'LVA', alpha2: 'LV', country: { en: 'Latvia', de: 'Lettland' } },
  { alpha3: 'LBN', alpha2: 'LB', country: { en: 'Lebanon', de: 'Libanon' } },
  { alpha3: 'LSO', alpha2: 'LS', country: { en: 'Lesotho', de: 'Lesotho' } },
  { alpha3: 'LBR', alpha2: 'LR', country: { en: 'Liberia', de: 'Liberia' } },
  { alpha3: 'LBY', alpha2: 'LY', country: { en: 'Libya', de: 'Libyen' } },
  { alpha3: 'LIE', alpha2: 'LI', country: { en: 'Liechtenstein', de: 'Liechtenstein' } },
  { alpha3: 'LTU', alpha2: 'LT', country: { en: 'Lithuania', de: 'Litauen' } },
  { alpha3: 'LUX', alpha2: 'LU', country: { en: 'Luxembourg', de: 'Luxemburg' } },
  { alpha3: 'MAC', alpha2: 'MO', country: { en: 'Macao', de: 'Macao' } },
  { alpha3: 'MDG', alpha2: 'MG', country: { en: 'Madagascar', de: 'Madagaskar' } },
  { alpha3: 'MWI', alpha2: 'MW', country: { en: 'Malawi', de: 'Malawi' } },
  { alpha3: 'MYS', alpha2: 'MY', country: { en: 'Malaysia', de: 'Malaysia' } },
  { alpha3: 'MDV', alpha2: 'MV', country: { en: 'Maldives', de: 'Malediven' } },
  { alpha3: 'MLI', alpha2: 'ML', country: { en: 'Mali', de: 'Mali' } },
  { alpha3: 'MLT', alpha2: 'MT', country: { en: 'Malta', de: 'Malta' } },
  { alpha3: 'MHL', alpha2: 'MH', country: { en: 'Marshall Islands', de: 'Marshallinseln' } },
  { alpha3: 'MTQ', alpha2: 'MQ', country: { en: 'Martinique', de: 'Martinique' } },
  { alpha3: 'MRT', alpha2: 'MR', country: { en: 'Mauritania', de: 'Mauretanien' } },
  { alpha3: 'MUS', alpha2: 'MU', country: { en: 'Mauritius', de: 'Mauritius' } },
  { alpha3: 'MYT', alpha2: 'YT', country: { en: 'Mayotte', de: 'Mayotte' } },
  { alpha3: 'MEX', alpha2: 'MX', country: { en: 'Mexico', de: 'Mexiko' } },
  {
    alpha3: 'FSM',
    alpha2: 'FM',
    country: { en: 'Micronesia (Federated States of)', de: 'Mikronesien' },
  },
  { alpha3: 'MDA', alpha2: 'MD', country: { en: 'Moldova, Republic of', de: 'Moldau' } },
  { alpha3: 'MCO', alpha2: 'MC', country: { en: 'Monaco', de: 'Monaco' } },
  { alpha3: 'MNG', alpha2: 'MN', country: { en: 'Mongolia', de: 'Mongolei' } },
  { alpha3: 'MNE', alpha2: 'ME', country: { en: 'Montenegro', de: 'Montenegro' } },
  { alpha3: 'MSR', alpha2: 'MS', country: { en: 'Montserrat', de: 'Montserrat' } },
  { alpha3: 'MAR', alpha2: 'MA', country: { en: 'Morocco', de: 'Marokko' } },
  { alpha3: 'MOZ', alpha2: 'MZ', country: { en: 'Mozambique', de: 'Mosambik' } },
  { alpha3: 'MMR', alpha2: 'MM', country: { en: 'Myanmar', de: 'Myanmar' } },
  { alpha3: 'NAM', alpha2: 'NA', country: { en: 'Namibia', de: 'Namibia' } },
  { alpha3: 'NRU', alpha2: 'NR', country: { en: 'Nauru', de: 'Nauru' } },
  { alpha3: 'NPL', alpha2: 'NP', country: { en: 'Nepal', de: 'Nepal' } },
  { alpha3: 'NLD', alpha2: 'NL', country: { en: 'Netherlands', de: 'Niederlande' } },
  { alpha3: 'NCL', alpha2: 'NC', country: { en: 'New Caledonia', de: 'Neu-Kaledonien' } },
  { alpha3: 'NZL', alpha2: 'NZ', country: { en: 'New Zealand', de: 'Neuseeland' } },
  { alpha3: 'NIC', alpha2: 'NI', country: { en: 'Nicaragua', de: 'Nicaragua' } },
  { alpha3: 'NER', alpha2: 'NE', country: { en: 'Niger', de: 'Niger' } },
  { alpha3: 'NGA', alpha2: 'NG', country: { en: 'Nigeria', de: 'Nigeria' } },
  { alpha3: 'NIU', alpha2: 'NU', country: { en: 'Niue', de: 'Niue' } },
  { alpha3: 'NFK', alpha2: 'NF', country: { en: 'Norfolk Island', de: 'Norfolkinsel' } },
  { alpha3: 'MKD', alpha2: 'MK', country: { en: 'North Macedonia', de: 'Nordmazedonien' } },
  {
    alpha3: 'MNP',
    alpha2: 'MP',
    country: { en: 'Northern Mariana Islands', de: 'Nördliche Marianneninseln' },
  },
  { alpha3: 'NOR', alpha2: 'NO', country: { en: 'Norway', de: 'Norwegen' } },
  { alpha3: 'OMN', alpha2: 'OM', country: { en: 'Oman', de: 'Oman' } },
  { alpha3: 'PAK', alpha2: 'PK', country: { en: 'Pakistan', de: 'Pakistan' } },
  { alpha3: 'PLW', alpha2: 'PW', country: { en: 'Palau', de: 'Palau' } },
  {
    alpha3: 'PSE',
    alpha2: 'PS',
    country: { en: 'Palestine, State of', de: 'Palästina, Bundesstaat' },
  },
  { alpha3: 'PAN', alpha2: 'PA', country: { en: 'Panama', de: 'Panama' } },
  { alpha3: 'PNG', alpha2: 'PG', country: { en: 'Papua New Guinea', de: 'Papua-Neuguinea' } },
  { alpha3: 'PRY', alpha2: 'PY', country: { en: 'Paraguay', de: 'Paraguay' } },
  { alpha3: 'PER', alpha2: 'PE', country: { en: 'Peru', de: 'Peru' } },
  { alpha3: 'PHL', alpha2: 'PH', country: { en: 'Philippines', de: 'Philippinen' } },
  { alpha3: 'PCN', alpha2: 'PN', country: { en: 'Pitcairn', de: 'Pitcairn' } },
  { alpha3: 'POL', alpha2: 'PL', country: { en: 'Poland', de: 'Polen' } },
  { alpha3: 'PRT', alpha2: 'PT', country: { en: 'Portugal', de: 'Portugal' } },
  { alpha3: 'PRI', alpha2: 'PR', country: { en: 'Puerto Rico', de: 'Puerto Rico' } },
  { alpha3: 'QAT', alpha2: 'QA', country: { en: 'Qatar', de: 'Katar' } },
  { alpha3: 'REU', alpha2: 'RE', country: { en: 'Réunion', de: 'Réunion' } },
  { alpha3: 'ROU', alpha2: 'RO', country: { en: 'Romania', de: 'Rumänien' } },
  { alpha3: 'RUS', alpha2: 'RU', country: { en: 'Russian Federation', de: 'Russland' } },
  { alpha3: 'RWA', alpha2: 'RW', country: { en: 'Rwanda', de: 'Ruanda' } },
  { alpha3: 'BLM', alpha2: 'BL', country: { en: 'Saint Barthélemy', de: 'St. Barthélemy' } },
  {
    alpha3: 'SHN',
    alpha2: 'SH',
    country: {
      en: 'Saint Helena, Ascension and Tristan da Cunha',
      de: 'St. Helena, Himmelfahrt und Tristan da Cunha',
    },
  },
  {
    alpha3: 'KNA',
    alpha2: 'KN',
    country: { en: 'Saint Kitts and Nevis', de: 'St. Kitts und Nevis' },
  },
  { alpha3: 'LCA', alpha2: 'LC', country: { en: 'Saint Lucia', de: 'St. Lucia' } },
  {
    alpha3: 'MAF',
    alpha2: 'MF',
    country: { en: 'Saint Martin (French part)', de: 'Saint Martin (französischer Teil)' },
  },
  {
    alpha3: 'SPM',
    alpha2: 'PM',
    country: { en: 'Saint Pierre and Miquelon', de: 'Saint Pierre und Miquelon' },
  },
  {
    alpha3: 'VCT',
    alpha2: 'VC',
    country: { en: 'Saint Vincent and the Grenadines', de: 'St. Vincent und die Grenadinen' },
  },
  { alpha3: 'WSM', alpha2: 'WS', country: { en: 'Samoa', de: 'Samoa' } },
  { alpha3: 'SMR', alpha2: 'SM', country: { en: 'San Marino', de: 'San Marino' } },
  {
    alpha3: 'STP',
    alpha2: 'ST',
    country: { en: 'Sao Tome and Principe', de: 'São Tomé und Príncipe' },
  },
  { alpha3: 'SAU', alpha2: 'SA', country: { en: 'Saudi Arabia', de: 'Saudi-Arabien' } },
  { alpha3: 'SEN', alpha2: 'SN', country: { en: 'Senegal', de: 'Senegal' } },
  { alpha3: 'SRB', alpha2: 'RS', country: { en: 'Serbia', de: 'Serbien' } },
  { alpha3: 'SYC', alpha2: 'SC', country: { en: 'Seychelles', de: 'Seychellen' } },
  { alpha3: 'SLE', alpha2: 'SL', country: { en: 'Sierra Leone', de: 'Sierra Leone' } },
  { alpha3: 'SGP', alpha2: 'SG', country: { en: 'Singapore', de: 'Singapur' } },
  {
    alpha3: 'SXM',
    alpha2: 'SX',
    country: { en: 'Sint Maarten (Dutch part)', de: 'Sint Maarten (niederländischer Teil)' },
  },
  { alpha3: 'SVK', alpha2: 'SK', country: { en: 'Slovakia', de: 'Slowakei' } },
  { alpha3: 'SVN', alpha2: 'SI', country: { en: 'Slovenia', de: 'Slowenien' } },
  { alpha3: 'SLB', alpha2: 'SB', country: { en: 'Solomon Islands', de: 'Salomonen' } },
  { alpha3: 'SOM', alpha2: 'SO', country: { en: 'Somalia', de: 'Somalia' } },
  { alpha3: 'ZAF', alpha2: 'ZA', country: { en: 'South Africa', de: 'Südafrika' } },
  {
    alpha3: 'SGS',
    alpha2: 'GS',
    country: {
      en: 'South Georgia and the South Sandwich Islands',
      de: 'Süd-Georgien und die südlichen Sandwich-Inseln',
    },
  },
  { alpha3: 'SSD', alpha2: 'SS', country: { en: 'South Sudan', de: 'Südsudan' } },
  { alpha3: 'ESP', alpha2: 'ES', country: { en: 'Spain', de: 'Spanien' } },
  { alpha3: 'LKA', alpha2: 'LK', country: { en: 'Sri Lanka', de: 'Sri Lanka' } },
  { alpha3: 'SDN', alpha2: 'SD', country: { en: 'Sudan', de: 'Sudan' } },
  { alpha3: 'SUR', alpha2: 'SR', country: { en: 'Suriname', de: 'Suriname' } },
  {
    alpha3: 'SJM',
    alpha2: 'SJ',
    country: { en: 'Svalbard and Jan Mayen', de: 'Spitzbergen und Jan Mayen' },
  },
  { alpha3: 'SWE', alpha2: 'SE', country: { en: 'Sweden', de: 'Schweden' } },
  { alpha3: 'CHE', alpha2: 'CH', country: { en: 'Switzerland', de: 'Schweiz' } },
  { alpha3: 'SYR', alpha2: 'SY', country: { en: 'Syrian Arab Republic', de: 'Syrien' } },
  {
    alpha3: 'TWN',
    alpha2: 'TW',
    country: { en: 'Taiwan, Province of China', de: 'Taiwan, Provinz Chinas' },
  },
  { alpha3: 'TJK', alpha2: 'TJ', country: { en: 'Tajikistan', de: 'Tadschikistan' } },
  { alpha3: 'TZA', alpha2: 'TZ', country: { en: 'Tanzania, United Republic of', de: 'Tansania' } },
  { alpha3: 'THA', alpha2: 'TH', country: { en: 'Thailand', de: 'Thailand' } },
  { alpha3: 'TLS', alpha2: 'TL', country: { en: 'Timor-Leste', de: 'Osttimor' } },
  { alpha3: 'TGO', alpha2: 'TG', country: { en: 'Togo', de: 'Togo' } },
  { alpha3: 'TKL', alpha2: 'TK', country: { en: 'Tokelau', de: 'Tokelau' } },
  { alpha3: 'TON', alpha2: 'TO', country: { en: 'Tonga', de: 'Tonga' } },
  {
    alpha3: 'TTO',
    alpha2: 'TT',
    country: { en: 'Trinidad and Tobago', de: 'Trinidad und Tobago' },
  },
  { alpha3: 'TUN', alpha2: 'TN', country: { en: 'Tunisia', de: 'Tunesien' } },
  { alpha3: 'TUR', alpha2: 'TR', country: { en: 'Turkey', de: 'Türkei' } },
  { alpha3: 'TKM', alpha2: 'TM', country: { en: 'Turkmenistan', de: 'Turkmenistan' } },
  {
    alpha3: 'TCA',
    alpha2: 'TC',
    country: { en: 'Turks and Caicos Islands', de: 'Turks und Caicosinseln' },
  },
  { alpha3: 'TUV', alpha2: 'TV', country: { en: 'Tuvalu', de: 'Tuvalu' } },
  { alpha3: 'UGA', alpha2: 'UG', country: { en: 'Uganda', de: 'Uganda' } },
  { alpha3: 'UKR', alpha2: 'UA', country: { en: 'Ukraine', de: 'Ukraine' } },
  {
    alpha3: 'ARE',
    alpha2: 'AE',
    country: { en: 'United Arab Emirates', de: 'Vereinigte Arabische Emirate' },
  },
  {
    alpha3: 'GBR',
    alpha2: 'GB',
    country: {
      en: 'United Kingdom of Great Britain and Northern Ireland',
      de: 'Vereinigtes Königreich',
    },
  },
  {
    alpha3: 'USA',
    alpha2: 'US',
    country: { en: 'United States of America', de: 'Vereinigte Staaten' },
  },
  {
    alpha3: 'UMI',
    alpha2: 'UM',
    country: {
      en: 'United States Minor Outlying Islands',
      de: 'Kleinere abgelegene Inseln der Vereinigten Staaten',
    },
  },
  { alpha3: 'URY', alpha2: 'UY', country: { en: 'Uruguay', de: 'Uruguay' } },
  { alpha3: 'UZB', alpha2: 'UZ', country: { en: 'Uzbekistan', de: 'Usbekistan' } },
  { alpha3: 'VUT', alpha2: 'VU', country: { en: 'Vanuatu', de: 'Vanuatu' } },
  {
    alpha3: 'VEN',
    alpha2: 'VE',
    country: { en: 'Venezuela (Bolivarian Republic of)', de: 'Venezuela' },
  },
  { alpha3: 'VNM', alpha2: 'VN', country: { en: 'Viet Nam', de: 'Vietnam' } },
  {
    alpha3: 'VGB',
    alpha2: 'VG',
    country: { en: 'Virgin Islands (British)', de: 'Virgin Inseln (Britisch)' },
  },
  {
    alpha3: 'VIR',
    alpha2: 'VI',
    country: { en: 'Virgin Islands (U.S.)', de: 'Virgin Inseln (USA)' },
  },
  { alpha3: 'WLF', alpha2: 'WF', country: { en: 'Wallis and Futuna', de: 'Wallis und Futuna' } },
  { alpha3: 'ESH', alpha2: 'EH', country: { en: 'Western Sahara', de: 'Westsahara' } },
  { alpha3: 'YEM', alpha2: 'YE', country: { en: 'Yemen', de: 'Jemen' } },
  { alpha3: 'ZMB', alpha2: 'ZM', country: { en: 'Zambia', de: 'Sambia' } },
  { alpha3: 'ZWE', alpha2: 'ZW', country: { en: 'Zimbabwe', de: 'Simbabwe' } },
];

/**
 * Returns a list of countries with value as alpha2 country code
 * and label the localized country name
 *
 * @param locale
 */
export const getSortedCountriesAlpha2Options = (locale: 'en' | 'de' = 'en') => {
  return countryCodeMap
    .map((country) => ({
      value: country.alpha2,
      label: country.country[locale],
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
};

/**
 * Returns a list of countries with value as aplha3 country code
 * and label the localized country name
 *
 * @param locale
 */
export const getSortedCountriesAlpha3Options = (locale: 'en' | 'de' = 'en') => {
  return countryCodeMap
    .map((country) => ({
      value: country.alpha3,
      label: country.country[locale],
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
};

/**
 * Searches the countriesList and returns an alpha2 country option
 * with the specified countryCode or undefined if such country code does not exist.
 *
 * @param countryCode
 * @param countriesList
 */
export const findCountryAlpha2OptionByCode = (
  countryCode: string | undefined,
): countryISO3166Map | undefined => {
  return countryCode
    ? countryCodeMap.find(
        (countryOption) => countryOption.alpha2.toUpperCase() === countryCode.toUpperCase(),
      )
    : undefined;
};

/**
 * Searches the countriesList and returns the country info with the given code
 *
 * @param countryCode
 */
export const findCountryAlpha3OptionByCode = (
  countryCode: string | undefined,
): countryISO3166Map | undefined => {
  return countryCode
    ? countryCodeMap.find(
        (countryOption) => countryOption.alpha3.toUpperCase() === countryCode.toUpperCase(),
      )
    : undefined;
};

export const getDefaultCountryValue = (
  fieldName: string,
  language: 'en' | 'de',
  codeType: 'alpha2' | 'alpha3' = 'alpha3',
): ElementsSDK.SelectOption | undefined => {
  const savedItem = sessionStorage.getItem(fieldName);
  const countryCode = savedItem ? JSON.parse(savedItem) : undefined;

  if (!countryCode) return undefined;

  let countryMap: countryISO3166Map | undefined;

  if (codeType === 'alpha2') {
    countryMap = findCountryAlpha2OptionByCode(countryCode);
  } else {
    countryMap = findCountryAlpha3OptionByCode(countryCode);
  }

  return countryMap ? { value: countryCode, label: countryMap.country[language] } : undefined;
};
